export default __webpack_public_path__ + "static/media/event-light.1fdd08f5.svg";